import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from "react-router-dom";

import { Button, Tabs, Alert  } from "flowbite-react";
import { HiAdjustments, HiClipboardList, HiUserCircle  } from "react-icons/hi";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon } from '@heroicons/react/24/outline'
import { MdDashboard, MdOutlineAttachFile  } from "react-icons/md";
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';

const resourceFile = ({ resourceId, onSubmit , onClose, isUpdating}) => {

    const hoy = new Date().toISOString().split('T')[0];
 
    const fileInputRef = useRef(null);
    const [areas, setAreas] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);


    const [formRecurso, setFormRecurso] = useState({
        folderName: "recurso",
        prefixFile: Date.now() + "-" + Math.round(Math.random() * 1e9),
        res_area: "",
        res_title: "",
        res_description: "",
        res_pathtype: "",
        res_pathurl: "",
        res_fecha: hoy,
        res_status: "",
      });

    const handleInputRecursoChange = (e) => {
        
        const { name, value } = e.target;
        setFormRecurso({ ...formRecurso, [name]: value });
    };

    const handleFileRecursoChange = (e) => {
        const { name, files } = e.target;
        setFormRecurso({ ...formRecurso, [name]: files[0] });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formRecurso);
    };

    const handleCancelRecurso = () => {
        setFormRecurso((prevState) => ({
            ...prevState, // Mantiene el valor actual de doc_areaid
            res_area: "",
            res_title: "",
            res_description: "",
            res_pathtype: "",
            res_pathurl: "",
            res_fecha: "",
            res_status: "",
            folderName: "recurso",
            prefixFile: Date.now() + "-" + Math.round(Math.random() * 1e9)
        }));
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        //setFormRecurso({ ...formRecurso, "doc_areaid" : areaId });
    };

    /*
    const handleSubmitResource = async () => {
        setIsLoading(true);
        try {
          //setFormRecurso({ ...formRecurso, "doc_areaid" : areaIdProp });
    
          const response = await axios.post(
            `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/resource/create`,formRecurso,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
          });
          

          if(response.data.status){
            alert("Archivo cargado correctamente");
            handleCancelRecurso();
            
          }else{
            alert("Problema al cargar el archivo intenta nuevamente");
          }
        } catch (error) {
          
        } finally{
            setIsLoading(false);
          }
    }
    */

    useEffect(()=>{
        const getAreas = async () => {
            setIsLoading(true);
            try {
                const endpoint = isUpdating
                    ? '/areas'
                    : '/areas-user/current';

                const response = await axios.get(
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}${endpoint}`,
                    {
                        withCredentials: true,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });
              setAreas(response.data);
            } catch (error) {
                
            } finally{
                setIsLoading(false);
              }
          }

        getAreas();
        
        if(resourceId){
            getResource();
        }
        
    },[resourceId,isUpdating]);
    const getResource = async () => {
        setIsLoading(true);
        try {
            const resources = await axios.get(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/resources/${resourceId}`,
                {
                    withCredentials: true,
                }
            );
            setFormRecurso(resources.data);
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }
    }
  return (
    <>
       {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
        <form onSubmit={handleSubmit} className="space-y-4 max-w-sm mx-auto">
            <div className='flex-col'>
                <input type="hidden" name="folderName" onChange={handleInputRecursoChange} value={formRecurso.folderName}/>      
                <input type="hidden" name="prefixFile" onChange={handleInputRecursoChange} value={formRecurso.prefixFile}/>   
                <div>
                    <label htmlFor="res_area" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Tipo</label>
                    <select  
                        name="res_area" 
                        id="res_area" 
                        value={formRecurso.res_area}
                        onChange={handleInputRecursoChange}
                        aria-describedby="helper-text-explanation" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                        >
                        <option value="">Seleccione area</option>
                        {areas.map((area) => (
                        <option key={area.id} value={area.id}>{area.name}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="res_title" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Nombre Archivo</label>
                    <input
                        type="text"
                        name="res_title"
                        value={formRecurso.res_title}
                        onChange={handleInputRecursoChange}
                        aria-describedby="helper-text-explanation" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                         
                    />
                </div>

                <div>
                    <label htmlFor="res_description" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Descripción (opcional)</label>
                    <textarea 
                    id="res_description" 
                    name="res_description" 
                    value={formRecurso.res_description}
                    onChange={handleInputRecursoChange}
                    rows="4" 
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                    placeholder="Descripción de la solución"></textarea>
                </div>

                <div>
                    <label htmlFor="res_pathtype" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Tipo de carga</label>
                    <select  
                        name="res_pathtype" 
                        id="res_pathtype" 
                        value={formRecurso.res_pathtype}
                        onChange={handleInputRecursoChange}
                        aria-describedby="helper-text-explanation" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                        >
                            <option value="">Seleccione tipo</option>
                            <option value="0">Selección de archivo</option>
                            <option value="1">Ingreso de url</option>
                        </select>

                </div>
                {formRecurso.res_pathtype === "1" && (
                    <div>
                        <label htmlFor="res_pathurl" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">URL del archivo</label>
                        <input
                            type="text"
                            name="res_pathurl"
                            value={formRecurso.res_pathurl}
                            onChange={handleInputRecursoChange}
                            aria-describedby="helper-text-explanation" 
                            placeholder="https://rutaalarchivo.com/archivo.pdf"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                         
                        />
                    </div>
                )}

                {(!isUpdating && formRecurso.res_pathtype === "0") && (
                    <div>
                        <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Cargar Archivo</label>
                        <input
                            type="file"
                            name="res_file"
                            ref={fileInputRef}
                            onChange={handleFileRecursoChange}
                            aria-describedby="helper-text-explanation" 
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                        
                        />
                    </div>
                )}
                <div>
                    <label htmlFor="res_fecha" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Fecha</label>
                    <input  
                        type="date"
                        name="res_fecha" 
                        id="res_fecha" 
                        value={formRecurso.res_fecha}
                        onChange={handleInputRecursoChange}
                        aria-describedby="helper-text-explanation" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                    />

                </div>

                <div>
                    <label htmlFor="res_status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Estado</label>
                    <select  
                        name="res_status" 
                        id="res_status" 
                        value={formRecurso.res_status}
                        onChange={handleInputRecursoChange}
                        aria-describedby="helper-text-explanation" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                        >
                            <option value="">Seleccione Estado</option>
                            <option value="0">Inactivo</option>
                            <option value="1">Activo</option>
                        </select>

                </div>
            </div>
            
            
            <div className='flex-col w-full lg:w-1/2'>
                <div className="flex justify-between mt-4">
                    <button
                    type="button"
                    onClick={handleCancelRecurso} 
                    onClose={onClose}
                    className="bg-gray-200  px-4 py-2 rounded"
                    >
                    Cancelar
                    </button>
                    <button
                    type="submit"
                    className="bg-green-400 px-4 py-2 rounded"
                    >
                    Guardar
                    </button>
                </div>
            </div>

        </form>
        
    </>
  )
}

export default resourceFile
